/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { setCurrencyFormat, colorsCombination } from '../../../utils/helpers';
import { CustomTooltip, saleskey, orderKey } from '../helper';

const DayWiseLineChart = ({
    dir, showTitle, categorisedBasedOn, index,
    currentYearMonthDayWise, height, category }) => {
    const { t } = useTranslation('common');
    const [color1] = colorsCombination[index % 10];

    const dataToShow = [];

    Object.keys((currentYearMonthDayWise)).forEach((dayMonthYear) => {
        const [day, month, year, dayofyear] = dayMonthYear.split('-');
        const { currentMonthAmount, orderCount } = currentYearMonthDayWise?.[dayMonthYear]
            ?.reduce((acc, item) => {
                acc.currentMonthAmount = Number(Number(Number(acc.currentMonthAmount) + Number(item.amount)).toFixed(2));
                acc.orderCount = Number(Number(Number(acc.orderCount) + Number(item.orderCount)).toFixed(2));
                return acc
            }, { currentMonthAmount: 0, orderCount: 0 }) ?? { currentMonthAmount: 0, orderCount: 0 };

        const currentMonthDataKey = `${day}, ${month} ${year}`;

        dataToShow.push({
            [saleskey]: currentMonthAmount,
            "day": `${currentMonthDataKey}`,
            currentMonthDataKey,
            category,
            [orderKey]: orderCount
        })
    })

    return (
        <Col xs={12}>
            <Card>
                <CardBody>
                    {showTitle ? <div className="card__title">
                        <h5 className="bold-text">{t('comparemonthlysales.compareDays')}</h5>
                    </div> : null}
                    <div dir="ltr">
                        <ResponsiveContainer height={height}>
                            <LineChart
                                data={dataToShow}
                                margin={{
                                    top: 0, right: 0, left: 25, bottom: 0,
                                }}
                            >
                                <XAxis dataKey="day" reversed={dir === 'rtl'} />
                                <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                                    tickFormatter={item => setCurrencyFormat(item, true)}
                                    width={90}
                                    allowDataOverflow
                                />
                                <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                                <Tooltip content={<CustomTooltip category={category} categorisedBasedOn={categorisedBasedOn} />} />
                                <Legend />
                                <Line dot={false} type="monotone" dataKey={saleskey?.toString()} stroke={color1 || '#3366ff'} strokeWidth={2} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

DayWiseLineChart.propTypes = {
    dir: PropTypes.string.isRequired,
    currentYearMonthDayWise: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    showTitle: PropTypes.bool,
    category: PropTypes.string.isRequired,
    categorisedBasedOn: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired
};

DayWiseLineChart.defaultProps = {
    showTitle: true
}

export default DayWiseLineChart;
